/**
 * @license
 * Copyright 2026 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 *
 * g3-prettier-ignore-file
 */

/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as models from "../models/index.js";
import { HTTPClient } from "./http.js";
import { Logger } from "./logger.js";
import { RetryConfig } from "./retries.js";
import { Params, pathToFunc } from "./url.js";

/**
 * Contains the list of servers available to the SDK
 */
export const ServerList = [
  /**
   * Global Endpoint
   */
  "https://generativelanguage.googleapis.com",
] as const;

export type SDKOptions = {
  /**
   * The security details required to authenticate the SDK
   */
  security?: models.Security | (() => Promise<models.Security>) | undefined;

  /**
   * Allows setting the api_version parameter for all supported operations
   */
  api_version?: string | undefined;

  /**
   * Allows setting the user_project parameter for all supported operations
   */
  user_project?: string | undefined;

  http_client?: HTTPClient;
  /**
   * Allows overriding the default server used by the SDK
   */
  server_idx?: number | undefined;
  /**
   * Allows overriding the default server URL used by the SDK
   */
  server_url?: string | undefined;
  /**
   * Allows overriding the default user agent used by the SDK
   */
  user_agent?: string | undefined;
  /**
   * Allows overriding the default retry config used by the SDK
   */
  retry_config?: RetryConfig;
  timeout_ms?: number;
  debug_logger?: Logger;
};

export function serverURLFromOptions(options: SDKOptions): URL | null {
  let serverURL = options.server_url;

  const params: Params = {};

  if (!serverURL) {
    const serverIdx = options.server_idx ?? 0;
    if (serverIdx < 0 || serverIdx >= ServerList.length) {
      throw new Error(`Invalid server index ${serverIdx}`);
    }
    serverURL = ServerList[serverIdx] || "";
  }

  const u = pathToFunc(serverURL)(params);
  return new URL(u);
}

export const SDK_METADATA = {
  language: "typescript",
  openapiDocVersion: "v1beta",
  sdkVersion: "2.4.1-preview.4",
  genVersion: "2.924.0",
  userAgent:
    "speakeasy-sdk/typescript 2.4.1-preview.4 2.924.0 v1beta @google/genai",
} as const;
